module.exports = __webpack_public_path__ + "img/cspace-instapage.92a5a7c6.svg";